export let PermissionType = {
  Accesss: 'Access',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  Print: 'Print',
  Export: 'Export'
};
